export function validateContact(c) {
  var errors = {};
  if (!c.firstName.trim()) errors.firstName = "Required";
  if (!c.lastName.trim()) errors.lastName = "Required";
  if (!c.email.trim()) errors.email = "Required";
  else if (c.email.indexOf("@") === -1) errors.email = "Enter a valid email";
  if (!c.address.trim()) errors.address = "Required";
  if (!c.city.trim()) errors.city = "Required";
  if (!c.state) errors.state = "Required";
  if (!c.zip.trim()) errors.zip = "Required";
  else if (!/^\d{5}$/.test(c.zip.trim())) errors.zip = "Enter a 5-digit ZIP";
  return errors;
}
